<script>
import {
  transactionSignalTypeLabels,
  transactionSignalLabels,
  valuesTransformFn,
} from '@/constants/transactionSignalConfig.js';
import SignalMetadataLine from '@/V2/documents/document-view/signals/SignalMetadataLine.vue';

export default {
  components: { SignalMetadataLine },
  props: {
    signal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      transactionSignalTypeLabels,
      transactionSignalLabels,
      valuesTransformFn,
      UI_HIDDEN_FIELDS: ['transactions', 'type', 'flagged'],
    };
  },
  computed: {},
  methods: {
    visibleKeys(detail) {
      return Object.keys(detail).filter(
        (key) => !this.UI_HIDDEN_FIELDS.includes(key),
      );
    },
  },
};
</script>

<template>
  <div class="transaction-signal d-flex flex-column i-gap-8">
    <div
      v-for="(detail, dIndex) in signal.details.filter(
        (d) => d.flagged !== false,
      )"
      :key="dIndex"
      class="transaction-type"
    >
      <div class="d-flex i-text-body-2 i-text-primary-110 i-mb-4">
        {{ transactionSignalTypeLabels[detail.type] || detail.type }}
      </div>

      <signal-metadata-line
        v-for="(detailKey, detailIndex) in visibleKeys(detail)"
        :key="detailIndex"
        :title="transactionSignalLabels[detailKey] || detailKey"
      >
        <template #value>
          <span>{{
            valuesTransformFn[detailKey]
              ? valuesTransformFn[detailKey](detail[detailKey])
              : detail[detailKey]
          }}</span>
        </template>
      </signal-metadata-line>
    </div>
  </div>
</template>
